import React from "react";
import { twMerge } from "tailwind-merge";

interface PageButtonsProps {
  currentPage: number;
  numPages: number;
  setPage: (p: number) => void;
}

const getNumberList = (
  sentinel: number,
  currentPage: number,
  numPages: number,
) => {
  if (numPages <= 5) {
    return [...Array(numPages).keys()].map((k) => k + 1);
  }

  // Add pages around current page
  if (currentPage <= 3) {
    // Near start: show 1,2,3,4,5,...,last
    return [1, 2, 3, 4, 5, sentinel, numPages];
  } else if (currentPage >= numPages - 2) {
    // Near end: show 1,...,last-4,last-3,last-2,last-1,last
    return [
      1,
      sentinel,
      numPages - 4,
      numPages - 3,
      numPages - 2,
      numPages - 1,
      numPages,
    ];
  } else {
    // Middle: show 1,...,current-1,current,current+1,...,last
    return [
      1,
      sentinel,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      sentinel,
      numPages,
    ];
  }
};

export const PageButtons = ({
  currentPage,
  numPages,
  setPage,
}: PageButtonsProps) => {
  // Sentinel is mapped to "..." instead of a button
  const sentinel = 0;
  const pageNumbers = getNumberList(sentinel, currentPage, numPages);

  return (
    <ul className="flex flex-row gap-2">
      {pageNumbers.map((num, index) => (
        <li key={`${num}-${index}`} aria-current={currentPage === num}>
          {num === sentinel ? (
            <span className="flex h-7 w-7 items-center justify-center pb-2 text-center text-neutral-variant-40 hover:cursor-default dark:text-neutral-variant-80">
              ...
            </span>
          ) : (
            <button
              onClick={() => setPage(num)}
              className={twMerge(
                "h-7 w-7 rounded-full text-neutral-variant-40 hover:bg-neutral-80 dark:text-neutral-variant-80 dark:hover:bg-neutral-40",
                currentPage === num &&
                  "bg-surface-container-highest dark:bg-surface-container-highest-dark",
              )}
            >
              {num}
            </button>
          )}
        </li>
      ))}
    </ul>
  );
};
